export default function DemoRoleSwitcher() {
    const presets = {
        HR: [ "ai_hr_access" ],
        Support: [ "ai_support_access" ],
        Product: [ "ai_arcci_access" ],
        Confluence: [ "ai_confluence_access" ],
        Admin:   [ "ai_admin", "ai_hr_access", "ai_support_access", "ai_confluence_access", "ai_roleprofile_access", "ai_arcci_access" ],
        General: []
    };

    const apply = (label) => {
        const demoUser = {
            email: `${ label.toLowerCase() }@arccorp.com`,
            roles: presets[label]
        };

        localStorage.setItem( "userInfo", JSON.stringify( demoUser ) );
        localStorage.setItem( "userRoles", JSON.stringify( demoUser.roles ) );
        window.location.reload();
    }

    return (
        <div className="flex gap-2 text-xs">
            {Object.keys(presets).map(label => (
                <button 
                    key={label}
                    onClick = { () => apply(label) }
                    className = "px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600"
                    title = {`Switch to ${label} demo user`}
                >
                    {label}
                </button>
            ))}
        </div>
    )

}